export default __webpack_public_path__ + "static/media/vision.782514d6.png";